import axios from "axios";
import { Auth } from "aws-amplify";
import { settings } from "../../main/configs/settings";

export class HelperResendEmailLogin {
  static async resendEmailLogin(id: number | undefined): Promise<boolean> {
    const baseApiUrl = `${settings.API_URL}/developers/send-email-login/${id}`;
    const session = await Auth.currentSession();
    const token = session.getIdToken().getJwtToken();
    try{ 
      const httpResponse = await axios.put(baseApiUrl, {}, {
        headers: {
          Authorization : `${token}`
        },
      });

      if(httpResponse.status === 200){
        return true;
      } 
    } catch(error) {
      console.error(error);
    }
    
    return false;
  }  
}

export default HelperResendEmailLogin;
